import { DataTable } from 'primereact/datatable';
import Heading from '../../../components/Heading/Heading';
import styles from '../../User Management/css/User.module.css';
import { useEffect, useState } from 'react';
import {
	generateApprovedConsentTemplateDetails,
	generateApprovedConsentTemplates,
	removeApprovedConsentTemplate,
} from '../../../utils/common.utils';
import { Column } from 'primereact/column';
import CONSTANTS from '../../../constants';
import { getMonthFormatDate, getTimestamp } from '../../../utils/getDate.utils';
import Icon from '../../../components/Icon/Icon';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import TemplateModal from '../../../components/TemplateModal/TemplateModal';
import CreateTemplates from '../Create/CreateTemplates';

const ListTemplates = () => {
	const [templates, setTemplates] = useState([]);
	const [templateDetails, setTemplateDetails] = useState({});

	useEffect(() => {
		generateApprovedConsentTemplates(setTemplates, false);
	}, []);

	// Active Approved Templates
	const activeTemplates = templates.filter((tempObj) => tempObj.active === 'Y');

	const creationDateTemplate = (field) => {
		const convertedTimestamp = getTimestamp(field.creationDate);
		const date = getMonthFormatDate(convertedTimestamp?.split(' ')[0]);
		const time = convertedTimestamp?.split(' ')[1];
		const ampm = convertedTimestamp?.split(' ')[2];
		return <span>{`${date} ${time} ${ampm}`}</span>;
	};

	const handleDeleteTemplate = (rowData) => {
		removeApprovedConsentTemplate(rowData.templateName, setTemplates);
	};

	const handleGetTemplateDetails = (rowData) => {
		generateApprovedConsentTemplateDetails(
			rowData.templateName,
			setTemplateDetails,
			templates,
			setTemplates
		);
	};

	// Updated handleEditTemplate function: passing the entire template details
	const handleEditTemplate = (rowData) => {
		// Get the temp object and change visibility
		const newTemplateList = templates.map((obj) => {
			if (obj.templateName === rowData.templateName) {
				const newTempObj = { ...obj, visibleEditable: true };
				return newTempObj;
			}
			return obj;
		});

		// Set the new temp list to re-render the rowData
		setTemplates(newTemplateList);
	};

	const actionBodyTemplate = (rowData) => {
		return (
			<div className={styles['actions__container']}>
				<Icon
					icon="edit"
					tooltip="Create an edit request"
					className={`${styles['actions-icon']} ${styles['table-icon']} edit`}
					onClick={() => handleEditTemplate(rowData)} // Passing entire rowData
				/>
				<Tooltip target=".edit" position="top" className={styles.tooltip} />
				<Dialog
					header="Edit template details"
					visible={rowData.visibleEditable}
					maximizable
					onHide={() => {
						// Change visibility when closing the dialog
						const newTemplateList = templates.map((obj) => {
							if (obj.templateName === rowData.templateName) {
								const newTempObj = { ...obj, visibleEditable: false };
								return newTempObj;
							}
							return obj;
						});
						setTemplates(newTemplateList);
					}}
				>
					<CreateTemplates
						isEditable
						templateDetails={rowData}
					/>
				</Dialog>
				<Icon
					icon="delete"
					tooltip="Create a delete request"
					className={`${styles['actions-icon']} ${styles['table-icon']} delete`}
					onClick={() => handleDeleteTemplate(rowData)}
				/>
				<Tooltip target=".delete" position="top" className={styles.tooltip} />
				<Button
					className={styles['action-button']}
					onClick={() => handleGetTemplateDetails(rowData)} // Passing the full template data
				>
					View Details
				</Button>
				<Dialog
					header="Template Details"
					visible={rowData.visible}
					onHide={() => {
						// Hide the dialog and reset the state for template details
						const updatedTemplateDetails = {
							...templateDetails,
							visible: false,
						};
						setTemplateDetails(updatedTemplateDetails);

						// Update the list with visibility change
						const updateApprovedTemplateList = templates.map((tempObj) =>
							tempObj.templateName === rowData.templateName
								? updatedTemplateDetails
								: tempObj
						);
						setTemplates(updateApprovedTemplateList);
					}}
				>
					<TemplateModal templateData={templateDetails} />
				</Dialog>
			</div>
		);
	};

	return (
		<div className="main">
			<Heading>List of approved templates</Heading>
			<div className={styles['user__container']}>
				<div className={styles['table__container']}>
					<DataTable
						value={activeTemplates}
						paginator
						rows={20}
						rowsPerPageOptions={[5, 10, 15, 20, 30, 50]}
						emptyMessage="No approved templates found."
						removableSort
					>
						{CONSTANTS.templateColumns.map((column) => (
							<Column
								key={column.field}
								field={column.field}
								header={column.header}
								sortable
							/>
						))}
						<Column
							body={creationDateTemplate}
							field="creationDate"
							header="Creation Date"
							sortable
						></Column>
						<Column
							body={actionBodyTemplate}
							field="actions"
							header="Template Actions"
						></Column>
					</DataTable>
				</div>
			</div>
		</div>
	);
};

export default ListTemplates;
